import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  canonical?: string;
  ogImage?: string;
  ogType?: string;
  structuredData?: object | object[];
  keywords?: string;
  noindex?: boolean;
}

const SEO = ({
  title = "Collectif Ibbü | Action des conseillers iAdvize/Ibbu",
  description = "Rejoignez l'action collective des anciens conseillers iAdvize/Ibbü pour faire valoir vos droits. Démarche juridique groupée, témoignages et solidarité.",
  canonical = "https://collectif-ibbu.org",
  ogImage = "https://collectif-ibbu.org/og-image.png",
  ogType = "website",
  structuredData,
  keywords = "Ibbü, Ibbu, iAdvize, conseillers Ibbu, action collective Ibbü, plateforme iAdvize, conseillers iAdvize, droits conseillers, freelance iAdvize",
  noindex = false
}: SEOProps) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical" href={canonical} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Collectif Ibbü" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonical} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Structured Data */}
      {structuredData && (
        Array.isArray(structuredData) ? (
          structuredData.map((data, index) => (
            <script key={index} type="application/ld+json">
              {JSON.stringify(data)}
            </script>
          ))
        ) : (
          <script type="application/ld+json">
            {JSON.stringify(structuredData)}
          </script>
        )
      )}
    </Helmet>
  );
};

export default SEO;
